import { useContext } from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography } from '@mui/material';
import { useStyles } from '../styles/workedTodayStyles';
import RunningTime from './RunningTime';
import { TimerContext } from '../context/TimerContext';

const WorkedToday = ({ initialLoading }) => {
  const classes = useStyles();
  const { loading } = useContext(TimerContext);
  return (
    <Stack className={classes.stack} sx={{ mt: 2 }}>
      {/* <Typography className={classes.labelText}>WORKED TODAY :</Typography> */}
      <Typography className={classes.timerText}>
        <RunningTime open={!loading && !initialLoading} />
      </Typography>
    </Stack>
  );
};

WorkedToday.propTypes = {
  initialLoading: PropTypes.bool,
};

export default WorkedToday;
